import Table from "react-bootstrap/Table";
import { FaFilePdf } from "react-icons/fa";
import { Link } from "react-router-dom";

const CustomTableII = ({ data, coll }) => {
  return (
    <div style={{ width: "100%" }}>
      <div className="table-responsive">
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "black", color: "white" }}>
                Sr.n.
              </th>
              {coll.map((item, index) => (
                <th
                  style={{ backgroundColor: "black", color: "white" }}
                  key={index}
                >
                  {item}
                </th>
              ))}
             
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index} style={{ height: 60 }}>
                <td>{index + 1}</td>

                {coll.map((col, colIndex) => (
                  <td key={colIndex}>{item[col.toLowerCase()] || ""}</td>
                ))}
               
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default CustomTableII;
